export default {
  table_ordering: 'Ordinazione al tavolo',
  table: 'Tavolo',
  pickup_or_delivery: 'Ritiro o consegna',
  asap: 'Il prima possibile',
  served_in: 'Servito in {{time}} min',
  not_taking_orders: 'Ordini non accettati',
  not_your_table: 'Non è il tuo tavolo? Scansiona il codice sul tuo.',
  eating_here: {
    title: 'Mangi qui?',
    back_to_table: 'Ordina per {{table}}. Te lo portiamo noi.',
    scan_code: 'Scansiona il codice QR sul tavolo per ordinare.',
  },
  notes: {
    table_unavailable: {
      title: 'Il codice QR di questo tavolo non funziona più.',
      text: 'Rivolgiti al personale. Puoi ancora ordinare per il ritiro.',
      text_no_pickup: 'Rivolgiti al personale.',
    },
    table_ordering_off: {
      title: 'L’ordinazione al tavolo al momento non è disponibile.',
      text: 'Puoi ordinare per il ritiro.',
    },
    load_failed: {
      title: 'Impossibile caricare il tuo tavolo.',
      text: 'Scansiona di nuovo il codice QR.',
    },
    closed: {
      title: 'Chiuso al momento.',
      text: 'Puoi ordinare al tavolo dalle {{time}}.',
      text_later: 'Potrai ordinare al tavolo quando riapriremo.',
    },
    paused: {
      title: 'Al momento non accettiamo ordini.',
      text: 'Rivolgiti al personale o riprova tra qualche minuto.',
    },
  },
  cart: {
    closed: 'Chiuso al momento. Puoi ordinare al tavolo dalle {{time}}. Il carrello viene conservato fino ad allora.',
    closed_later: 'Chiuso al momento. Il carrello viene conservato fino alla riapertura.',
    paused: 'Al momento non accettiamo ordini. Il carrello viene conservato. Rivolgiti al personale.',
  },
  cash_note: 'Paga in contanti alla cassa.',
  confirmation: {
    bring_to_table: 'Porteremo il tuo ordine al tavolo.',
    your_table: 'Il tuo tavolo',
    moved_table: 'Hai cambiato tavolo? Comunica al personale il numero del tuo ordine <strong>{{number}}</strong>.',
  },
  served: 'Servito',
};
